import styled from 'styled-components'

// TODO: improve this, use it for anything like a panel
// add elevations with different shadows
// add size and color?
export default styled.div`
  box-shadow: 0 2.5px 20px #ddd;
  border-radius: 5px;
`
